import React from "react";

export default () => {
	return (
		<div id="property-detail-hero-image-badge">
			<img src="/images/aqarchain-verified.svg" alt="" className="mr-2"/> Aqarverified
		</div>
	);
};
